Date.prototype.Format = function (fmt) { //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default {

    methods: {
        alertRS(rs) {
            this.$alert(this.rs[rs])
        },
        confirmRS(rs) {
            return this.$confirm(this.rs[rs])
        },
        checkNull(field, rs) {
            if (this.$isNull(field)) {
                this.alertRS(rs)
                return false
            }
            return true
        },
        rights(key) {
            const rightList = this.config && this.config.rights ? this.config.rights : this.rightList
            if (!rightList) return false;
            return rightList.indexOf(key) != -1
        },
        showDateInput: function (callback, key) {
            var elm = event.srcElement;
            var tmp = elm.getAttribute("class");
            if (tmp && tmp.indexOf("date-input-readonly") === -1 && (this.readOnly == true || this.disabled)) return;

            tmp = this.lan;
            var obj = {};
            obj.lan = tmp;
            obj.el = elm

            tmp = elm.getAttribute("noErrorDeal");
            if (tmp && tmp === "true") {
                obj.errDealMode = -1;
            }
            obj.onpicked = (dp) => {
                if (key) callback[key] = dp.cal.getNewDateStr()
                else callback.data = dp.cal.getNewDateStr()
            };
            obj.oncleared = (dp) => {
                if (key) callback[key] = dp.cal.getNewDateStr()
                else callback.data = dp.cal.getNewDateStr()
            };
            WdatePicker(obj);
        },
        showDateInput: function (callback, key) {
            var elm = event.srcElement;
            var tmp = elm.getAttribute("class");
            if (tmp && tmp.indexOf("date-input-readonly") === -1 && (this.readOnly == true || this.disabled)) return;

            tmp = this.lan;
            var obj = {};
            obj.lan = tmp;
            obj.el = elm

            tmp = elm.getAttribute("noErrorDeal");
            if (tmp && tmp === "true") {
                obj.errDealMode = -1;
            }
            obj.onpicked = (dp) => {
                if (key) callback[key] = dp.cal.getNewDateStr()
                else callback.data = dp.cal.getNewDateStr()
            };
            obj.oncleared = (dp) => {
                if (key) callback[key] = dp.cal.getNewDateStr()
                else callback.data = dp.cal.getNewDateStr()
            };
            WdatePicker(obj);
        }
    },
    data() {
        return {
            formatter: {
                fdate(t) {
                    if (t) {
                       if(typeof t == "string") return t.substring(0, 10)
                       else if(t.Format) return t.Format("yyyy-MM-dd")
                    }
                    return ""
                },
                ftime(t) {
                    if (t) return t.substring(11, 19)
                    else return ""
                },
                fstime(t) {
                    if (t) return t.substring(11, 16)
                    else return ""
                },
                fdateTime(t) {
                    if (t) return t.substring(0, 10) + ' ' + t.substring(11, 19)
                    else return ""
                },
                numberFix1(d) {
                    if (d) return d.toFixed(1)
                },
                numberFix2(d) {
                    if (d) return d.toFixed(2)
                },
                numberFix3(d) {
                    if (d) return d.toFixed(3)
                },
                numberFix4(d) {
                    if (d) return d.toFixed(4)
                }
            },
            fdate: {
                thisDate() {
                    return new Date().Format("yyyy-MM-dd")
                },
                firstOfMonth(d) {
                    if (!d) d = new Date()
                    d.setDate(1)
                    return d.Format("yyyy-MM-dd")
                },
                lastOfMonth(d) {
                    if (!d) d = new Date()
                    d.setMonth(d.getMonth() + 1)
                    d.setDate(0)
                    return d.Format("yyyy-MM-dd")
                }
            }
        }

    }
}